import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function AdminAudit() {
  const { user, t, checkingAuth } = useApp();
  const [items, setItems] = useState([]);
  const [action, setAction] = useState("");
  useEffect(() => { if (user?.role === "admin") api.get("/admin/audit-log", { params: action ? { action } : {} }).then(r => setItems(r.data.items)); }, [user?.role, action]);
  if (checkingAuth) return null;
  if (!user) return <Navigate to="/auth" />;
  if (user.role !== "admin") return <div className="p-8">403 — Admin only.</div>;
  const actions = ["submitted", "approve", "request_changes", "reject", "resubmitted", "edited", "edited_by_admin", "changes_submitted", "changes_approved", "unpublish", "cancelled", "postponed", "archived", "sold_out", "feature", "unfeature", "deleted"];
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-6 py-6 md:py-8" data-testid="admin-audit">
      <Link to="/admin" className="eyebrow inline-flex items-center gap-1 hover:underline"><ArrowLeft className="w-3 h-3" />{t("admin")}</Link>
      <div className="mt-3 flex items-end justify-between gap-3 flex-wrap border-b border-foreground pb-3">
        <h1 className="font-display uppercase text-4xl md:text-5xl tracking-tighter">{t("auditLog")}</h1>
        <select className="gg-input !py-2 w-auto" value={action} onChange={e => setAction(e.target.value)} data-testid="audit-filter">
          <option value="">{t("allTypes")}</option>{actions.map(a => <option key={a} value={a}>{a.replace(/_/g, " ")}</option>)}
        </select>
      </div>
      <ul className="mt-4 divide-y divide-foreground border border-foreground text-sm" data-testid="audit-list">
        {items.map(x => (
          <li key={x.log_id} className="p-3 grid md:grid-cols-[150px_140px_1fr_1fr] gap-x-3 gap-y-1">
            <span className="text-xs text-muted-foreground">{x.created_at.slice(0, 16).replace("T", " ")}</span>
            <span className="font-display uppercase">{x.action.replace(/_/g, " ")}</span>
            <span>{x.target_event ? <Link to={`/admin/events/${x.target_event}`} className="underline">{x.event_name || x.target_event}</Link> : "—"}
              {x.prev_status !== x.new_status && x.new_status && <span className="ml-2 text-xs text-muted-foreground">{x.prev_status || "—"} → {x.new_status}</span>}</span>
            <span className="text-muted-foreground">{t("actor")} {x.actor_name || x.actor_id}{x.comment && <span className="block italic text-xs">“{x.comment}”</span>}</span>
          </li>))}
        {!items.length && <li className="p-8 text-center eyebrow">—</li>}
      </ul>
    </div>
  );
}
